import { useContext } from "react";

import ProposalOutputContext from "../../../context/ProposalOutputContext";

import Grid from "@mui/material/Grid";
import Button from '@mui/material/Button';
import Box from "@mui/material/Box";

import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const OutputFooter = () => {
  const {
    handleSaveProposaltoSharepointBtnClick, handleBack, handleSaveDraftBtnClick,
  } = useContext(ProposalOutputContext);
  return (
    <Grid
      size={{ xs: 12 }}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        backgroundColor: '#FFFFFF',
        borderTop: '1px solid #E5E7EB',
        boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.05), 0 -2px 4px -1px rgba(0, 0, 0, 0.03)',
        p: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mx: 2,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{
            textTransform: 'none',
            color: '#475569',
            borderColor: '#CBD5E1',
            '&:hover': {
              borderColor: '#475569',
              backgroundColor: '#F8FAFC',
            }
          }}
        >
          Back
        </Button>

        <Box
          sx={{
            display: 'flex',
            gap: 2
          }}
        >
          <Button
            variant="outlined"
            startIcon={<SaveIcon />}
            color="success"
            onClick={handleSaveDraftBtnClick}
            sx={{
              textTransform: 'none',
              color: '#475569',
              borderColor: '#CBD5E1',
              '&:hover': {
                borderColor: '#475569',
                backgroundColor: '#F8FAFC',
              }
            }}
          >
            Save as draft
          </Button>
          <Button
            variant="contained"
            startIcon={<FileUploadIcon />}
            onClick={handleSaveProposaltoSharepointBtnClick}
            sx={{
              textTransform: 'none',
              backgroundColor: '#0f172a',
              '&:hover': {
                backgroundColor: '#1E293B',
              },
            }}
          >
            Upload to SharePoint
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default OutputFooter;